<template>
  <div class="nav_bar">
    <template v-if="showLoggedInContent && isEngineer && navItems.length">
      <HKLSelect
        v-if="isMobile"
        v-model="displayItem"
        :options="navItems"
        :placeholder="placeholder"
        :align="'right'"
        @select="activatePage"
      />
      <ul v-else>
        <template
          v-for="(item, index) of navItems"
        >
          <li
            :key="index"
            :active="item.isActive"
            @click="() => activatePage(item.value)"
          >
            {{ item.label }}
          </li>
        </template>
      </ul>
    </template>
  </div>
</template>
<script>
import { computed, getCurrentInstance, unref } from 'vue-demi'
import { useStoreGetters } from '@/store'
import { aclHelper } from '@/utils/aclHelper'
import navigation from '@/utils/navigation'
import userHelper from '@/utils/userHelper'
import HKLSelect from '@/controls/Select/HKLSelect'
import useLoginStatus from '../useLoginStatus'
import { useEnableCms } from '../CmsModulesStatusMixin'
import { useActivePage } from './hook'
import { ACTIVE_PAGE } from './consts'
import { getDashboard } from '@/utils/dashboardUtils'

export default {
  components: {
    HKLSelect,
  },
  setup () {
    const { proxy } = getCurrentInstance()
    const { isEngineer, currentUser } = useStoreGetters('user', ['isEngineer', 'currentUser'])
    const {
      enableTenantProjectsFeature,
      enableDirectoryFeature,
      enableWorkPermitsFeature,
    } = useStoreGetters('regions', [
      'enableTenantProjectsFeature',
      'enableDirectoryFeature',
      'enableWorkPermitsFeature',
    ])
    const { isMobile } = userHelper.useMobileUA()
    const activePage = useActivePage()
    const { showLoggedInContent } = useLoginStatus()
    const enableCms = useEnableCms()

    const showCms = computed(() => {
      return unref(enableCms) && (aclHelper.hasTendersAccess() || aclHelper.hasProjectsAccess())
    })
    const showTms = computed(() => {
      return (unref(enableTenantProjectsFeature) || unref(enableDirectoryFeature)) && aclHelper.showTmsDashboard()
    })
    const showWP = computed(() => {
      return unref(enableWorkPermitsFeature) && aclHelper.showWorkPermitDashboard()
    })
    const navItems = computed(() => {
      const list = [
        {
          key: ACTIVE_PAGE.HOME,
          enabled: unref(showCms),
          label: proxy.$t('settings.dashboard.cms'),
        },
        {
          key: ACTIVE_PAGE.ENGINEER_DASHBOARD,
          enabled: unref(showTms),
          label: proxy.$t('settings.dashboard.tms'),
        },
        {
          key: ACTIVE_PAGE.WORKPERMIT_DASHBOARD,
          enabled: unref(showWP),
          label: proxy.$t('settings.dashboard.wp'),
        },
      ]
        .filter(item => item.enabled)
        .map((item) => ({
          ...item,
          isActive: unref(activePage) === item.key,
          get name () {
            return item.label
          },
          get value () {
            return item.key
          },
        }))
      return list
    })
    const placeholder = computed(() => {
      const user = unref(currentUser)
      const key = getDashboard(user.dashboard, {
        hasCmsAccess: () => unref(showCms),
        hasTmsAccess: () => unref(showTms),
        hasWpAccess: () => unref(showWP),
      })
      const item = unref(navItems).find(item => item.key === key)
      return item ? item.name : undefined
    })
    const displayItem = computed({
      get () {
        const currentItem = unref(navItems).find(item => item.value === unref(activePage))
        return currentItem ? currentItem.value : undefined
      },
      set (val) {
        activePage.value = val
      },
    })

    const activatePage = (routerName) => {
      if (unref(isEngineer)) {
        navigation.setLastDashboardTab(routerName)
      }
      activePage.value = routerName
      proxy.$router.push({ name: routerName })
    }

    return {
      isEngineer,
      showLoggedInContent,
      displayItem,
      navItems,
      placeholder,
      activatePage,
      isMobile,
    }
  },
}
</script>

<style scoped lang="scss">
@import '~styles/settings';
@import 'styles';

.nav_bar {
  flex-basis: 400px;
  flex-grow: 1;
  flex-shrink: 1;
  ul {
    height: 100%;
    width: 100%;
    margin-bottom: 0;
    margin-left: 25px;
    li {
      display: inline-block;
      height: 100%;
      color: #FFFFFF;
      cursor: pointer;
      padding-top: 30px;
      width: 166px;
      min-width: 100px;
      text-align: center;
      font-family: Verdana;
      font-size: 14px;
    }
    li[active] {
      border-bottom: 6px solid #165F90;
    }
  }
  .mobile-device & {
    @include header-selector;
  }
  .hkl-select {
    align-self: center;
    margin-right: 12px;
    width: 175px + 31px;
    [lang=zh-CN] & {
      width: 120px;
    }
  }
}
</style>
